import RequestedVaspsTable from './RequestedVaspsTable'

export default RequestedVaspsTable
